document.addEventListener('countdown:started', (e) => {

	const settings = e.detail;
	window.__countdown_is_started = true;
	window.__last_countdown_settings = settings;

	//console.log('Applying countdown related settings:', settings)
	const heroWrapper = document.querySelector('[collection-product-hero-wrapper]');
  const collectionCountdown = document.querySelector('[collection-countdown-hero-wrapper]');

  const heroEnabled = window.__collectionSettings?.heroEnabled;
  const showHeroDuringCountdown = window.__collectionSettings?.showHeroDuringCountdown;

  if (heroEnabled && heroWrapper && collectionCountdown) {

    if (!showHeroDuringCountdown) {
      heroWrapper.classList.add('hidden');
      collectionCountdown.classList.remove('hidden');
    } else {
      heroWrapper.classList.remove('hidden');
      collectionCountdown.classList.add('hidden');
    }

  }

	if(settings.showBlackDealSection) {
		const showBlackDealSection = document.querySelector('[show-section-with-countdown]');
		if(showBlackDealSection) {
			showBlackDealSection.classList.remove('hidden');
		}
	}	

	if(settings.showButtonSection) {
		const showButtonSection = document.querySelector('[countdown-button-is-shown]');
		if(showButtonSection) {
			showButtonSection.classList.remove('hidden');
		}
	}

	if(settings.hideHeroButton) {
		const hiddenButton = document.querySelector('[countdown-hide-button]');
		if(hiddenButton) {
			hiddenButton.classList.add('hidden');
		}
	}

	if(settings.hideSkinTypeFilter) {
		const skinTypeFilter = document.querySelector('[hide-skin-type-with-countdown]');
		if(skinTypeFilter) {
			skinTypeFilter.classList.add('hidden');
		}
	}
	
	if(settings.heroText != undefined) {
		//console.log('Changing countdown hero text');
		const countdownText = document.querySelector('[countdown-text]');
		const defaultText = document.querySelector('[default-text]');
		if (countdownText && defaultText) {
			countdownText.textContent = settings.heroText;
			countdownText.classList.remove('hidden');
			defaultText.classList.add('hidden');
		}
	}

	if(settings.hideHeroSubtext) {
		//console.log('Hiding hero subtext');
		const subText = document.querySelector('[countdown-hide-hero-subtext]');
		if (subText) {
			subText.classList.add('hidden');
		}
	}

	if(settings.reduceMobileHeroPadding) {
		//console.log('Reducing mobile hero padding');
		const reducedPaddingHero = document.querySelector('[reduced-mobile-padding]')
		if(reducedPaddingHero) {
			reducedPaddingHero.classList.add('reduced-padding');
		}
	}

	updateCountdownImage(settings);
	updateCountdownImageLink(settings);
	// Button settings
	const countdownBtn = document.querySelector('[countdown-btn]');
	const defaultBtn = document.querySelector('[default-btn]');

	if (countdownBtn && defaultBtn) {

		if (settings.countdownBtnUrl) {
			countdownBtn.href = settings.countdownBtnUrl;
		}
		if (settings.countdownBtnText) {
			countdownBtn.textContent = settings.countdownBtnText;
		}
		if (settings.countdownBtnColor) {
			countdownBtn.style.backgroundColor = settings.countdownBtnColor;
		}
		if (
			settings.countdownBtnUrl ||
			settings.countdownBtnText ||
			settings.countdownBtnColor
		) {
			countdownBtn.classList.remove('hidden');
			defaultBtn.classList.add('hidden');
		}

	}
});

function updateCountdownImageLink(settings) {
	const countdownImg = document.querySelector('[countdown-image]');
	if (!countdownImg) return;

	const existingLink = countdownImg.closest('a[countdown-image-link]');
	
	if (settings.countdownImageUrl && settings.countdownBtnUrl) {
		if (!existingLink) {
			const link = document.createElement('a');
			link.href = settings.countdownBtnUrl;
			link.setAttribute('countdown-image-link', '');
			countdownImg.parentNode.insertBefore(link, countdownImg);
			link.appendChild(countdownImg);
		} else {
			existingLink.href = settings.countdownBtnUrl;
		}
	} else {
		// Remove link if conditions fail
		if (existingLink && existingLink.hasAttribute('countdown-image-link')) {
			existingLink.parentNode.insertBefore(countdownImg, existingLink);
			existingLink.remove();
		}
	}
}



document.addEventListener('countdown:ended', () => {
	updateCountdownImageLink({});

	const countdownText = document.querySelector('[countdown-text]');
	const defaultText = document.querySelector('[default-text]');
	const subText = document.querySelector('[countdown-hide-hero-subtext]');
	const reducedPaddingHero = document.querySelector('[reduced-mobile-padding]');
	const hiddenButton = document.querySelector('[countdown-hide-button]');
	const showButtonSection = document.querySelector('[countdown-button-is-shown]');
	const showBlackDealSection = document.querySelector('[show-section-with-countdown]');
	const skinTypeFilter = document.querySelector('[hide-skin-type-with-countdown]');
	const countdownBtn = document.querySelector('[countdown-btn]');
	const defaultBtn = document.querySelector('[default-btn]');
	const countdownImg = document.querySelector('[countdown-image]');
	const defaultImg = document.querySelector('[default-image]');

	const heroWrapper = document.querySelector('[collection-product-hero-wrapper]');
  const collectionCountdown = document.querySelector('[collection-countdown-hero-wrapper]');
  const heroEnabled = window.__collectionSettings?.heroEnabled;

  if (heroEnabled && heroWrapper && collectionCountdown) {
    heroWrapper.classList.remove('hidden');
    collectionCountdown.classList.add('hidden');
  }
	

	if (countdownImg && defaultImg) {
		countdownImg.classList.add('hidden');
		defaultImg.classList.remove('hidden');
		countdownImg.setAttribute('data-src', '');
	}

	if (countdownText && defaultText) {
		countdownText.classList.add('hidden');
		defaultText.classList.remove('hidden');
	}

	if (countdownBtn && defaultBtn) {
		const defaultHref = defaultBtn.getAttribute('href');
		countdownBtn.href = defaultHref;
		countdownBtn.textContent = defaultBtn.textContent
		countdownBtn.style.backgroundColor = '';
		countdownBtn.classList.add('hidden');
		defaultBtn.classList.remove('hidden');
	}

	if (subText) {
		subText.classList.remove('hidden');
	}
	if(reducedPaddingHero) {
		reducedPaddingHero.classList.remove('reduced-padding');
	}
	if(hiddenButton) {
		hiddenButton.classList.remove('hidden');
	}
	if(showButtonSection) {
		showButtonSection.classList.add('hidden');
	}
	if(showBlackDealSection) {
		showBlackDealSection.classList.add('hidden');
	}
	if(skinTypeFilter) {
		skinTypeFilter.classList.remove('hidden');
	}

  window.__countdown_is_started = false;
	window.__last_countdown_settings = null;
	
});

function isStaticBannerLang() {
	if (typeof Weglot !== 'undefined' && typeof Weglot.getCurrentLang === 'function') {
		const lang = Weglot.getCurrentLang();
		return ['nl', 'sv', 'da', 'es', 'it'].includes(lang);
	}
	return false;
}

function updateCountdownImage(settings) {
	const countdownImg = document.querySelector('[countdown-image]');
	const defaultImg = document.querySelector('[default-image]');
	if (!countdownImg || !defaultImg) return;

	// if no countdown image or other lang → show default
	if (!settings.countdownImageUrl || isStaticBannerLang()) {
		countdownImg.classList.add('hidden');
		defaultImg.classList.remove('hidden');
		countdownImg.setAttribute('data-src', '');
		return;
	}

	// show countdown image
		countdownImg.src = settings.countdownImageUrl;
		countdownImg.setAttribute('data-src', settings.countdownImageUrl);
		defaultImg.classList.add('hidden');
		countdownImg.classList.remove('hidden');
}

function waitForWeglot() {
	if (typeof Weglot !== 'undefined' && typeof Weglot.on === 'function') {
		Weglot.on('languageChanged', () => {
			if (window.__countdown_is_started && window.__last_countdown_settings) {
				updateCountdownImage(window.__last_countdown_settings);
				updateCountdownImageLink(window.__last_countdown_settings);
			}
		});

		// Run once when Weglot is ready
		if (window.__countdown_is_started && window.__last_countdown_settings) {
			updateCountdownImage(window.__last_countdown_settings);
			updateCountdownImageLink(window.__last_countdown_settings);
		}
	} else {
		setTimeout(waitForWeglot, 50);
	}
}

waitForWeglot();